<template>
  <TransitionGroup class="transition-group-block" :name="name" :tag="tag" v-bind="$attrs">
    <slot></slot>
  </TransitionGroup>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'defaultTransitionGroup'
  },
  tag: {
    type: String,
    default: 'ul'
  }
})
</script>

<style lang="scss">
.transition-group-block {
  position: relative;
  padding: 0;
  list-style-type: none;
}
// 默认动效 淡出偏移
.defaultTransitionGroup-move, /* 对移动中的元素应用的过渡 */
.defaultTransitionGroup-enter-active,
.defaultTransitionGroup-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.defaultTransitionGroup-enter-from,
.defaultTransitionGroup-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* 确保将离开的元素从布局流中删除
  以便能够正确地计算移动的动画。 */
.defaultTransitionGroup-leave-active {
  position: absolute;
}
</style>
